import { useState, useEffect } from "react";
import JsxParser from "react-jsx-parser";
import StaffNav from "./managernav";
import { useNavigate, useLocation } from "react-router-dom";
import NoteTaker from "./notetaker";
import { format } from "date-fns";
import IndividualStaffData from "./individalstaff";
import TaskGraph from "./taskgraph";
import TaskTraining from "./tasktraining";
import CreateProject from "./projectmeeting";
import Brainstorm from "./Brainstorm";

// Check if the app is running in an Electron environment
const isElectron = window && window.process && window.process.type;

export default function CourseViewer() {
  // Hooks must be declared first
  const navigate = useNavigate();
  const location = useLocation();

  const courseDocName = location.state.meeting.TrainingDocName;
  const meeting = location.state.meeting;
  const isBrainstormDoc = courseDocName === "Brainstorm";

  // State variables (now location and meeting are available)
  const [trainingDocuments, setTrainingDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [documentsPerPage] = useState(1); // Documents per page
  const [start, setStart] = useState(() => {
    // Initialize from localStorage, with meeting ID as key for specific meeting persistence
    const savedState = localStorage.getItem(`meeting_started_${meeting?.id}`);
    return savedState ? JSON.parse(savedState) : false;
  });
  const [end, setEnd] = useState(false);
  const [appraisal, setAppraisal] = useState([]);
  const [clockins, setClockins] = useState([]);
  const [selectedMethods, setSelectedMethods] = useState(() => {
    // Also persist selected methods for this specific meeting
    const savedMethods = localStorage.getItem(`meeting_methods_${meeting?.id}`);
    return savedMethods ? JSON.parse(savedMethods) : [];
  });
  const [show, setShow] = useState(false);
  const [staffData, setStaffData] = useState(null);
  const [rawClockins, setRawClockins] = useState([]);
  const [ time, setTime ] = useState(0);
  const [task, setTask] = useState(false);
  const [step, setStep] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(false);
  

  console.log(staffData);

  console.log("Meeting:", meeting.Type);

  // Persist start state to localStorage whenever it changes
  useEffect(() => {
    if (meeting?.id) {
      localStorage.setItem(`meeting_started_${meeting.id}`, JSON.stringify(start));
    }
  }, [start, meeting?.id]);

  // Persist selected methods to localStorage whenever they change
  useEffect(() => {
    if (meeting?.id) {
      localStorage.setItem(`meeting_methods_${meeting.id}`, JSON.stringify(selectedMethods));
    }
  }, [selectedMethods, meeting?.id]);

  // Clean up localStorage when meeting ends
  useEffect(() => {
    if (end && meeting?.id) {
      localStorage.removeItem(`meeting_started_${meeting.id}`);
      localStorage.removeItem(`meeting_methods_${meeting.id}`);
    }
  }, [end, meeting?.id]);

  // Add beforeunload event listener to maintain state on page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Don't clear localStorage on page refresh - let it persist
      console.log("Page unloading - maintaining meeting state in localStorage");
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      // Note: We don't clear localStorage here to maintain persistence across refreshes
    };
  }, []);

  // Check for existing meeting state on component mount
  useEffect(() => {
    if (meeting?.id) {
      const savedStartState = localStorage.getItem(`meeting_started_${meeting.id}`);
      const savedMethods = localStorage.getItem(`meeting_methods_${meeting.id}`);
      
      if (savedStartState) {
        const isStarted = JSON.parse(savedStartState);
        if (isStarted && !start) {
          setStart(true);
          console.log("Restored meeting started state from localStorage");
        }
      }
      
      if (savedMethods && selectedMethods.length === 0) {
        const methods = JSON.parse(savedMethods);
        if (methods.length > 0) {
          setSelectedMethods(methods);
          setShow(true);
          console.log("Restored selected methods from localStorage:", methods);
        }
      }
    }
  }, [meeting?.id]); // Only run when meeting ID is available

  // we want a useEffect and if in Electron then we want to open the external link in the default browser and send the parameters to the link

  useEffect(() => {
    // If Google Meet, do not open notetaker automatically
    if (meeting.Location === 'Google Meet') return;

    const url = `https://app.insightos.co.uk/notetaker/${meeting.id}`;
    if (isElectron) {
      // In Electron, send IPC to main process to open in Chrome
      try {
        const { ipcRenderer } = window.require("electron");
        ipcRenderer.send("open-external-url", { url, browserName: "chrome" });
      } catch (err) {
        console.error("Electron IPC error:", err);
      }
    } else {
      // In web, try to open in Chrome via protocol (not possible), fallback to window.open
      window.open(url, "_blank");
    }
  }, [meeting.id, meeting.Location]);




  useEffect(() => {
    console.log("Inside useEffect: meeting.Type =", meeting.Type);
    if (meeting.Type === "Appraisal") {
      const getAppraisals = async () => {
        const appraisalId = meeting.DocType;
        const response = await fetch(
          `https://api.insightos.co.uk/api/meetingapr/${appraisalId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: 'include',

          }
        );
        const data = await response.json();
        console.log(data.data);
        setAppraisal(data.data);
      };
  
      getAppraisals();
    }
  }, [meeting.Type]);
  


const token = localStorage.getItem('token');

  useEffect(() => {

    // Get today's clockins
    const getClockins = async () => {
  
      const response = await fetch("https://api.insightos.co.uk/api/clockins", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",

        },
        credentials: 'include',
      });
  
      const data = await response.json();
      console.log("Clockins Data:", data.data);
  
      // Get the meeting. Attendees and turn it into an array and trim whitespaces
      const attendees = meeting.Attendees.split(",").map(name => name.trim());
      console.log("Attendees:", attendees);
  
      // Turn data.data into an array of StaffNames
      const clockinArray = data.data.map((clockin) => clockin.StaffName);
      console.log("Clockins:", clockinArray);

      setRawClockins(data.data);
  
      // Match the attendees with the clockins
      const filteredClockins = clockinArray.filter((clockin) => {
        return attendees.includes(clockin.trim()); // Trim clockin as well, just in case
      });
  
      console.log("Filtered Clockins:", filteredClockins);
  
      // Now set the filtered clockins
      setClockins(filteredClockins);
    };
  
    getClockins();
  
  }, [meeting]);
  

  // Debug log for courseDocName
  console.log(courseDocName);




  // Fetch training documents on component mount or when courseDocName changes
  useEffect(() => {
    const fetchTrainingDocuments = async () => {

      // if courseDocName is Task then I want you to setTask to true

      setTask(courseDocName === "Task");

      if (courseDocName === "Brainstorm") {
        setTrainingDocuments([]);
        return;
      }
    
      try {
        const response = await fetch(
          `https://api.insightos.co.uk/api/courseviewer/${courseDocName}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",

            },
            credentials : 'include',

          }
        );

        if (response.ok) {
          const data = await response.json();
          // Sort documents by page before setting state
          const sortedDocuments = data.data.sort((a, b) => a.Page - b.Page);
          setTrainingDocuments(sortedDocuments);
        } else {
          console.error("Failed to fetch training documents");
        }
      } catch (error) {
        console.error("Error fetching training documents:", error);
      }
    };

    fetchTrainingDocuments();
  }, [courseDocName]);

  // Start meeting handler
  const startMeeting = async (meeting) => {
    try {
      // Show the UI component or modal indicating that the meeting is starting
      setShow(true);
  console.log(selectedMethods);
      // Construct the URL to open the meeting in the note-taker page

      // selectedMethods is an array i want you to map through the array and match rawClockins with the StaffName and return the id for the clockin
      



  
      // Make an API call to start the meeting
      const response = await fetch("https://api.insightos.co.uk/api/startmeeting", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({
          id: meeting.id,
          Attended: selectedMethods, // Assuming selectedMethods is an array or object that needs to be sent
        }),
      });
  
      // Check if the response is successful
      if (!response.ok) {
        throw new Error("Failed to start meeting");
      }
  
      console.log("Meeting started successfully!");
      setStart(true); // This will trigger the localStorage persistence via useEffect
      
      // Additional logging for debugging
      console.log("Meeting state persisted to localStorage with key:", `meeting_started_${meeting.id}`);
      console.log("Selected methods persisted to localStorage with key:", `meeting_methods_${meeting.id}`);

    } catch (error) {
      // Catch and log any errors that occur during the process
      console.error("Error starting meeting:", error);
    }
  };


  

  // End meeting handler
  const endMeeting = async (meeting) => {

    const attendedClockins = selectedMethods.map(method => {
      const clockin = rawClockins.find(clockin => clockin.StaffName === method);
      return clockin ? clockin.id : null;
    }).filter(id => id !== null);

    console.log("Attended Clockins:", attendedClockins);


    console.log("Meeting:", meeting);


    


    try {
      const response = await fetch("https://api.insightos.co.uk/api/endmeeting", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({meeting: meeting.id, id: attendedClockins}),
      });

      if (!response.ok) {
        throw new Error("Failed to end meeting");
      }

      console.log("Meeting ended successfully!");
      setEnd(true);
      navigate("/dashboard");
    } catch (error) {
      console.error("Error ending meeting:", error);
    }
  };

  // Pagination logic
  const indexOfLastDocument = currentPage * documentsPerPage;
  const indexOfFirstDocument = indexOfLastDocument - documentsPerPage;
  const currentDocuments = trainingDocuments.slice(
    indexOfFirstDocument,
    indexOfLastDocument
  );

  // Handle "Next" button click
  const nextPage = () => {
    if (currentPage < Math.ceil(trainingDocuments.length / documentsPerPage)) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  // Handle "Previous" button click
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNotificationMethodChange = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      // Add to selected methods
      setSelectedMethods((prev) => [...prev, value]);
      setShow(true);
    } else {
      // Remove from selected methods
      setSelectedMethods((prev) => prev.filter((method) => method !== value));
    }
  };

  if (selectedMethods.length === 1) {
    console.log("Selected Method:", selectedMethods);
  }

  const handleRearrangeMeeting = async () => {
    // Delete the meeting and create a new one

    const response = await fetch(`https://api.insightos.co.uk/api/deletemeeting/${meeting.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      console.log("Meeting deleted successfully!");
      navigate("/createmeeting");
    } else {
      console.error("Failed to delete meeting");
    }
  };

  // i want the time to show and how long the meeting has been going on for
  useEffect(() => {
    if (start) {
      const interval = setInterval(() => {
        setTime((prev) => prev + 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [start]);

  // Format time properly to show MM:SS instead of HH:MM:SS
  const formatElapsedTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Handle fullscreen mode and body overflow
  useEffect(() => {
    if (isFullscreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    // Cleanup function to reset on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isFullscreen]);

  // Handle ESC key to exit fullscreen
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape' && isFullscreen) {
        setIsFullscreen(false);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [isFullscreen]);


// i want a function if task is true then i want to show the task graph and task training components but i want them on different pages

// i want to show the task graph on the first page and the task training on the second page







  

  // Progress percentage
  const progressPercentage =
    (currentPage / Math.ceil(trainingDocuments.length / documentsPerPage)) *
    100;

    return (
      <>
        {!isFullscreen && <StaffNav />}
        <div className={`${isFullscreen ? 'fixed inset-0 z-50 bg-white overflow-hidden' : 'min-h-screen'}`}>
          {/* Large Screen: Professional Design */}
          <div className={`${isFullscreen ? 'flex h-screen w-full overflow-hidden' : 'hidden lg:flex min-h-screen'} ${isFullscreen ? 'bg-white' : 'bg-gradient-to-br from-slate-50 to-blue-50'}`}>
            <div className={`w-full ${isFullscreen ? 'max-w-none h-full flex flex-col' : 'max-w-7xl'} mx-auto p-6`}>
              
              {/* Header Section */}
              {!isFullscreen && (
              <div className="mb-6 bg-white rounded-xl shadow-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Meeting Dashboard</h1>
                    <p className="text-gray-600">Manage your meeting session and track progress</p>
                  </div>
                  <div className="flex items-center space-x-4">
                    {show && !start && (
                      <button
                        onClick={() => startMeeting(meeting)}
                        data-component="meeting-session-controls"
                        data-time-saved="4"
                        data-feature="start_meeting_post"
                        className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-6 py-3 rounded-lg font-semibold shadow-lg transition-all duration-200 flex items-center space-x-2"
                      >
                        <span>🚀</span>
                        <span>Start Meeting</span>
                      </button>
                    )}
                    {start && (
                      <button
                        onClick={() => endMeeting(meeting)}
                        data-component="meeting-session-controls"
                        data-time-saved="3"
                        data-feature="end_meeting_post"
                        className="bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 text-white px-6 py-3 rounded-lg font-semibold shadow-lg transition-all duration-200 flex items-center space-x-2"
                      >
                        <span>⛔</span>
                        <span>End Meeting</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
              )}

              <div className={`grid gap-6 ${isFullscreen ? 'grid-cols-1 h-full' : 'grid-cols-12'}`}>
                
                {/* Left Sidebar - Meeting Info & Attendance */}
                {!isFullscreen && (
                <div className="col-span-4 space-y-6">
                  
                  {/* Meeting Details Card */}
                  <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
                    <div className="flex items-center mb-4">
                      <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-blue-600 text-lg">📅</span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">Meeting Details</h3>
                    </div>

                    {/* Google Meet Header */}
                    {meeting.Location === 'Google Meet' && (
                      <div className="mb-4 p-3 bg-[#e8f0fe] border border-[#1a73e8] rounded-lg flex items-center gap-3">
                        <img src="https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_1x_web_512dp.png" alt="Google Meet" className="h-8 w-8" />
                        <div>
                          <h4 className="text-[#1a73e8] font-bold text-sm">Google Meet Session</h4>
                          <p className="text-[#1a73e8] text-xs">Please complete attendance and record the meeting.</p>
                        </div>
                      </div>
                    )}
                    
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600 font-medium">Name:</span>
                        <span className="text-gray-900 font-semibold">{meeting.Name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600 font-medium">Time:</span>
                        <span className="text-gray-900">{meeting.Time}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600 font-medium">Type:</span>
                        <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md text-sm font-medium">{meeting.Type}</span>
                      </div>
                      {start && (
                        <div className="flex justify-between items-center bg-green-50 p-3 rounded-lg border border-green-200">
                          <span className="text-green-700 font-medium">Time Elapsed:</span>
                          <span className="text-green-900 font-bold text-lg">{formatElapsedTime(time)}</span>
                        </div>
                      )}
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Notes:</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">{meeting.Notes}</p>
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <h4 className="text-sm font-semibold text-gray-700 mb-2">Invited Attendees:</h4>
                      <p className="text-gray-600 text-sm leading-relaxed">{meeting.Attendees}</p>
                    </div>

                    {/* Upload Audio for Google Meet */}
                    {meeting.Location === 'Google Meet' && (
                      <div className="mt-4 pt-4 border-t border-gray-200">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">Meeting Recording:</h4>
                        <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100">
                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                </svg>
                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span> audio</p>
                                <p className="text-xs text-gray-500">MP3, WAV, M4A</p>
                            </div>
                            <input type="file" className="hidden" accept="audio/*" onChange={(e) => {
                                // Handle file upload
                                console.log(e.target.files[0]);
                            }} />
                        </label>
                      </div>
                    )}
                  </div>

                  {/* Attendance Register Card */}
                  <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
                    <div className="flex items-center mb-4">
                      <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                        <span className="text-green-600 text-lg">✓</span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">Attendance Register</h3>
                    </div>
                    
                    <div className="space-y-3">
                      {clockins.length > 0 ? (
                        clockins.map((notificationMethod, index) => (
                          <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-150">
                            <input
                              onChange={handleNotificationMethodChange}
                              value={notificationMethod}
                              id={notificationMethod}
                              name="notification-method"
                              type="checkbox"
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <label
                              htmlFor={notificationMethod}
                              className="ml-3 text-sm font-medium text-gray-900 cursor-pointer"
                            >
                              {notificationMethod}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                          <p className="text-red-700 font-medium text-sm mb-3">
                            No staff members clocked in for this meeting
                          </p>
                          <button 
                            onClick={handleRearrangeMeeting}
                            className="bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg text-sm font-semibold transition-colors duration-200"
                          >
                            🔄 Rearrange Meeting & Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                )}

                {/* Main Content Area */}
                <div className={`${isFullscreen ? 'col-span-1 w-full h-full flex flex-col' : 'col-span-8'}`}>
                  <div className={`bg-white rounded-xl shadow-lg border border-gray-200 p-6 ${isFullscreen ? 'h-full flex flex-col overflow-hidden' : 'min-h-[600px]'}`}>
                    <div className="flex items-center justify-between mb-6 flex-shrink-0">
                      <div className="flex items-center">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
                          <span className="text-purple-600 text-lg">📋</span>
                        </div>
                        <h3 className={`${isFullscreen ? 'text-3xl' : 'text-lg'} font-semibold text-gray-900`}>Meeting Content</h3>
                      </div>
                      <button
                        onClick={() => setIsFullscreen(!isFullscreen)}
                        className={`bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white ${isFullscreen ? 'px-6 py-4 text-lg' : 'px-4 py-2'} rounded-lg font-semibold shadow-lg transition-all duration-200 flex items-center space-x-2`}
                      >
                        <span>{isFullscreen ? "📥" : "📤"}</span>
                        <span>{isFullscreen ? "Exit Fullscreen" : "Fullscreen"}</span>
                      </button>
                    </div>

                    <div className={`${isFullscreen ? 'flex-1 overflow-y-auto' : ''}`}>

                    {meeting.ProjectId ? (
                      <div className="mb-6">
                        <CreateProject prop={meeting.ProjectId} />
                      </div>
                    ) : null}

                    {isBrainstormDoc && (
                      <div className="mb-6">
                        <Brainstorm
                          projectId={meeting.ProjectId || null}
                          projectName={meeting.Name || 'Brainstorm'}
                          brainstormId={meeting.BrainstormId || meeting.brainstormId || null}
                        />
                      </div>
                    )}
                    
                    {/* Conditional Rendering for Task Section */}
                    {task && (
                      <div className="space-y-6">
                        <div className={`bg-gray-50 rounded-lg p-4 border border-gray-200 ${isFullscreen ? 'min-h-[600px]' : ''}`}>
                          {step === 1 && <TaskGraph />}
                          {step === 2 && <TaskTraining />}
                        </div>

                        {/* Navigation Buttons */}
                        <div className="flex justify-between">
                          <button
                            onClick={() => setStep(step - 1)}
                            disabled={step === 1}
                            className={`${isFullscreen ? 'px-8 py-4 text-xl' : 'px-6 py-3'} rounded-lg font-semibold transition-all duration-200 ${
                              step === 1 
                                ? "opacity-50 cursor-not-allowed bg-gray-200 text-gray-400" 
                                : "bg-blue-600 hover:bg-blue-700 text-white shadow-lg"
                            }`}
                          >
                            ← Previous
                          </button>
                          <button
                            onClick={() => setStep(step + 1)}
                            disabled={step === 2}
                            className={`${isFullscreen ? 'px-8 py-4 text-xl' : 'px-6 py-3'} rounded-lg font-semibold transition-all duration-200 ${
                              step === 2 
                                ? "opacity-50 cursor-not-allowed bg-gray-200 text-gray-400" 
                                : "bg-green-600 hover:bg-green-700 text-white shadow-lg"
                            }`}
                          >
                            Next →
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Conditional Rendering for Non-Appraisal Meetings */}
                    {meeting.Type !== "Appraisal" && !task && !isBrainstormDoc && (
                      <div className="space-y-6">
                        {currentDocuments.map((doc, index) => (
                          <div key={index} className={`bg-gray-50 rounded-lg p-6 border border-gray-200 ${isFullscreen ? 'min-h-[600px]' : ''}`}>
                            <div className={`prose max-w-none ${isFullscreen ? 'prose-lg' : ''}`}>
                              <JsxParser components={{}} jsx={doc.Code} />
                            </div>

                            {/* Navigation Buttons */}
                            <div className="flex justify-between mt-6 pt-6 border-t border-gray-200">
                              <button
                                onClick={prevPage}
                                className={`${isFullscreen ? 'px-8 py-4 text-xl' : 'px-6 py-3'} bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-all duration-200 shadow-lg`}
                              >
                                ← Previous
                              </button>
                              <button
                                onClick={nextPage}
                                className={`${isFullscreen ? 'px-8 py-4 text-xl' : 'px-6 py-3'} bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-all duration-200 shadow-lg`}
                              >
                                Next →
                              </button>
                            </div>

                            {/* Progress Display */}
                            <div className={`mt-6 bg-white p-4 rounded-lg border border-gray-200 ${isFullscreen ? 'text-lg' : ''}`}>
                              <div className="flex justify-between items-center mb-2">
                                <span className={`${isFullscreen ? 'text-lg' : 'text-sm'} font-medium text-gray-700`}>Progress</span>
                                <span className={`${isFullscreen ? 'text-lg' : 'text-sm'} font-bold text-blue-600`}>{Math.min(progressPercentage, 100).toFixed(1)}%</span>
                              </div>
                              <div className={`w-full bg-gray-200 rounded-full ${isFullscreen ? 'h-4' : 'h-2'}`}>
                                <div 
                                  className={`bg-blue-600 ${isFullscreen ? 'h-4' : 'h-2'} rounded-full transition-all duration-300`}
                                  style={{ width: `${Math.min(progressPercentage, 100)}%` }}
                                />
                              </div>
                              <p className={`${isFullscreen ? 'text-base' : 'text-xs'} text-gray-500 mt-2 text-center`}>
                                Pages Viewed: {currentPage} out of {Math.ceil(trainingDocuments.length / documentsPerPage)}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    

                    {/* Conditional Rendering for Appraisals */}
                    {meeting.Type === "Appraisal" && (
                      <div className="space-y-6">
                        {appraisal.map((appraisalData, index) => (
                          <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                            <div className="flex items-center justify-between mb-6">
                              <div>
                                <h4 className="text-xl font-bold text-gray-900">Appraisal Information</h4>
                                <p className="text-gray-600">Performance review and feedback analysis</p>
                              </div>
                              <div className="flex space-x-3">
                                <button
                                  onClick={() => setStaffData({ id: appraisalData.StaffId })}
                                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-semibold transition-colors duration-200"
                                >
                                  📊 View Staff Data
                                </button>
                                {staffData && (
                                  <button
                                    onClick={() => setStaffData(null)}
                                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-semibold transition-colors duration-200"
                                  >
                                    ✕ Hide Staff Data
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Staff Data Section */}
                            {staffData && (
                              <div className="mb-6 bg-white rounded-lg p-4 border border-gray-200">
                                <IndividualStaffData staff={staffData} />
                              </div>
                            )}

                            {/* Appraisal Details */}
                            {!staffData && (
                              <div className="bg-white rounded-lg overflow-hidden border border-gray-200">
                                <div className="divide-y divide-gray-200">
                                  {[
                                    { label: "Staff Name", value: appraisalData.StaffName },
                                    { label: "Review Period From", value: appraisalData.ReviewPeriodFrom ? format(new Date(appraisalData.ReviewPeriodFrom), 'MMM dd, yyyy') : 'N/A' },
                                    { label: "Review Period To", value: appraisalData.ReviewPeriodTo ? format(new Date(appraisalData.ReviewPeriodTo), 'MMM dd, yyyy') : 'N/A' },
                                    { label: "Overall Performance", value: appraisalData.OverallPerformance },
                                    { label: "Key Strengths", value: appraisalData.KeyStrengths },
                                    { label: "Areas for Improvement", value: appraisalData.AreasForImprovement },
                                    { label: "Performance Goals Met", value: appraisalData.PerformanceGoalsMet },
                                    { label: "Examples Exceeding Expectations", value: appraisalData.ExamplesExceedingExpectations },
                                    { label: "Deadlines Targets Met", value: appraisalData.DeadlinesTargetsMet },
                                    { label: "Leadership and Teamwork Skills", value: appraisalData.LeadershipTeamworkSkills },
                                    { label: "Feedback from Peers", value: appraisalData.FeedbackFromPeers },
                                    { label: "Development Goals", value: appraisalData.DevelopmentGoals },
                                    { label: "Recommended Training Courses", value: appraisalData.RecommendedTrainingCourses },
                                    { label: "AI Training Report", value: appraisalData.AITrainingReport },
                                    { label: "Skills for Career Advancement", value: appraisalData.SkillsForCareerAdvancement },
                                    { label: "Compensation and Benefits Updates", value: appraisalData.CompensationBenefitsUpdates },
                                    { label: "Overall Summary", value: appraisalData.OverallSummary },
                                    { label: "Role Responsibility Changes", value: appraisalData.RoleResponsibilityChanges },
                                    { label: "Action Plan", value: appraisalData.ActionPlan },
                                    { label: "Employee Comments", value: appraisalData.EmployeeComments },
                                  ].map(({ label, value }, i) => (
                                    <div key={i} className="px-6 py-4 hover:bg-gray-50 transition-colors duration-150">
                                      <div className="flex flex-col sm:flex-row sm:justify-between">
                                        <dt className="text-sm font-semibold text-gray-900 mb-1 sm:mb-0">{label}</dt>
                                        <dd className="text-sm text-gray-700 sm:max-w-md">{value || 'N/A'}</dd>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile: Futuristic Design */}
          <div className={`${isFullscreen ? 'fixed inset-0 z-50 bg-white' : 'lg:hidden min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900'} p-3`}>
            <div className={`${isFullscreen ? 'h-full w-full' : 'max-w-md'} mx-auto`}>
            {/* Mobile Header Card */}
            {!isFullscreen && (
            <div className="mb-4 p-4 bg-gradient-to-br from-gray-800/90 via-blue-800/90 to-purple-800/90 backdrop-blur-lg border border-cyan-500/30 rounded-2xl shadow-2xl shadow-cyan-500/20">
              <h3 className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400 mb-2">
                🤖 {meeting.Name}
              </h3>

              {/* Google Meet Header Mobile */}
              {meeting.Location === 'Google Meet' && (
                <div className="mb-3 p-2 bg-[#e8f0fe]/10 border border-[#1a73e8]/50 rounded-lg flex items-center gap-2">
                  <img src="https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_1x_web_512dp.png" alt="Google Meet" className="h-6 w-6" />
                  <div>
                    <h4 className="text-[#1a73e8] font-bold text-xs">Google Meet Session</h4>
                    <p className="text-gray-300 text-[10px]">Please complete attendance and record.</p>
                  </div>
                </div>
              )}
              
              <div className="space-y-2 text-xs">
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Time:</span>
                  <span className="text-cyan-300">{meeting.Time}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400">Type:</span>
                  <span className="text-purple-300">{meeting.Type}</span>
                </div>
                {start && (
                  <div className="flex items-center justify-between">
                    <span className="text-gray-400">Elapsed:</span>
                    <span className="text-green-300">{formatElapsedTime(time)}</span>
                  </div>
                )}
              </div>

              <div className="mt-3 text-xs">
                <p className="text-gray-400 mb-1">Notes:</p>
                <p className="text-gray-200 text-xs leading-relaxed">{meeting.Notes}</p>
              </div>

              <div className="mt-3 text-xs">
                <p className="text-gray-400 mb-1">Attendees:</p>
                <p className="text-gray-200 text-xs leading-relaxed">{meeting.Attendees}</p>
              </div>

              {/* Mobile Control Buttons */}
              <div className="mt-4 flex gap-2">
                {show && !start && (
                  <button
                    onClick={() => startMeeting(meeting)}
                    data-component="meeting-session-controls"
                    data-feature="start_meeting_post"
                    data-time-saved="4"
                    className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white py-2 px-3 rounded-xl transition-all duration-300 text-xs font-bold border border-green-400/50 shadow-lg shadow-green-500/25"
                  >
                    🚀 Start Session
                  </button>
                )}
                {start && (
                  <button
                    onClick={() => endMeeting(meeting)}
                    data-component="meeting-session-controls"
                    data-feature="end_meeting_post"
                    data-time-saved="1"
                    className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-500 hover:to-pink-500 text-white py-2 px-3 rounded-xl transition-all duration-300 text-xs font-bold border border-red-400/50 shadow-lg shadow-red-500/25"
                  >
                    ⛔ Terminate Session
                  </button>
                )}
              </div>
            </div>
            )}

            {/* Mobile Attendance Card */}
            {!isFullscreen && (
            <div className="mb-4 p-4 bg-black/50 border border-cyan-500/40 rounded-xl backdrop-blur-sm">
              <h4 className="font-semibold text-cyan-300 text-sm mb-3 flex items-center">
                <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2 animate-pulse"></span>
                 Attendance Register
              </h4>
              
              <div className="space-y-2">
                {clockins.length > 0 ? (
                  clockins.map((notificationMethod, index) => (
                    <div key={index} className="flex items-center p-2 bg-gray-900/60 rounded-lg border border-cyan-500/20">
                      <input
                        onChange={handleNotificationMethodChange}
                        value={notificationMethod}
                        id={`mobile-${notificationMethod}`}
                        name="notification-method"
                        type="checkbox"
                        className="w-3 h-3 appearance-none rounded border border-gray-400 bg-gray-800 checked:bg-cyan-500 checked:border-cyan-400 focus:ring-2 focus:ring-cyan-500/50"
                      />
                      <label
                        htmlFor={`mobile-${notificationMethod}`}
                        className="ml-2 text-xs font-medium text-gray-200"
                      >
                        {notificationMethod}
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="p-3 bg-red-900/50 border border-red-500/30 rounded-lg">
                    <p className="text-red-300 text-xs font-medium mb-2">
                      No signatures detected
                    </p>
                    <button 
                      onClick={handleRearrangeMeeting}
                      data-component="meeting-session-controls"
                      data-time-saved="5"
                      data-feature="reschedule_meeting_post"
                      className="bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-500 hover:to-pink-500 text-white py-1 px-2 rounded-lg text-xs font-bold border border-red-400/50"
                    >
                      🔄 Reschedule Portal
                    </button>
                  </div>
                )}
              </div>
            </div>
            )}

            {/* Mobile Content Card */}
            <div className={`p-4 ${isFullscreen ? 'bg-white border-gray-200' : 'bg-black/50 border-purple-500/40'} border rounded-xl backdrop-blur-sm ${isFullscreen ? 'h-full w-full m-0 rounded-none' : ''}`}>
              <div className="flex items-center justify-between mb-3">
                <h4 className={`font-semibold ${isFullscreen ? 'text-gray-900 text-lg' : 'text-purple-300 text-sm'} flex items-center`}>
                  <span className={`w-2 h-2 ${isFullscreen ? 'bg-blue-400' : 'bg-purple-400'} rounded-full mr-2 animate-pulse`}></span>
                 Interface Content
                </h4>
                <button
                  onClick={() => setIsFullscreen(!isFullscreen)}
                  className={`bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white ${isFullscreen ? 'py-2 px-4 text-sm' : 'py-1 px-2 text-xs'} rounded-lg font-bold border border-purple-400/50 transition-all duration-300`}
                >
                  {isFullscreen ? "📥 Exit" : "📤"}
                </button>
              </div>

              <div className={`${isFullscreen ? 'bg-gray-50 border-gray-200' : 'bg-gray-900/60 border-purple-500/20'} p-3 rounded-lg border overflow-y-auto scrollbar-thin scrollbar-thumb-purple-500/50 scrollbar-track-gray-800/50 ${isFullscreen ? 'h-[calc(100vh-100px)]' : 'max-h-[400px]'}`}>
                {meeting.ProjectId ? (
                  <div className="mb-4">
                    <CreateProject prop={meeting.ProjectId} />
                  </div>
                ) : null}

                {isBrainstormDoc && (
                  <div className="mb-4">
                    <Brainstorm
                      projectId={meeting.ProjectId || null}
                      projectName={meeting.Name || 'Brainstorm'}
                      brainstormId={meeting.BrainstormId || meeting.brainstormId || null}
                    />
                  </div>
                )}
                
                {task && (
                  <div className="mb-4">
                    <div className="mb-3">
                      {step === 1 && <TaskGraph />}
                      {step === 2 && <TaskTraining />}
                    </div>

                    <div className="flex justify-between gap-2">
                      <button
                        onClick={() => setStep(step - 1)}
                        disabled={step === 1}
                        className={`flex-1 py-2 px-3 rounded-lg text-xs font-bold transition-all duration-300 ${
                          step === 1 
                            ? "opacity-50 cursor-not-allowed bg-gray-700 text-gray-400" 
                            : "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white border border-blue-400/50"
                        }`}
                      >
                        ← Previous
                      </button>
                      <button
                        onClick={() => setStep(step + 1)}
                        disabled={step === 2}
                        className={`flex-1 py-2 px-3 rounded-lg text-xs font-bold transition-all duration-300 ${
                          step === 2 
                            ? "opacity-50 cursor-not-allowed bg-gray-700 text-gray-400" 
                            : "bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 text-white border border-green-400/50"
                        }`}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                )}

                {meeting.Type !== "Appraisal" && !isBrainstormDoc ? (
                  currentDocuments.map((doc, index) => (
                    <div key={index} className="mb-4">
                      <div className="text-xs text-gray-300 font-mono">
                        <JsxParser components={{}} jsx={doc.Code} />
                      </div>

                      <div className="flex justify-between gap-2 mt-3">
                        <button
                          onClick={prevPage}
                          className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white py-2 px-3 rounded-lg text-xs font-bold border border-purple-400/50"
                        >
                          ← Previous
                        </button>
                        <button
                          onClick={nextPage}
                          className="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white py-2 px-3 rounded-lg text-xs font-bold border border-purple-400/50"
                        >
                          Next →
                        </button>
                      </div>

                      <div className="mt-3 text-center">
                        <div className="bg-gray-800/60 p-2 rounded-lg border border-gray-600/30">
                          <p className="text-xs font-medium text-cyan-300">
                           Progress: {Math.min(progressPercentage, 100).toFixed(1)}%
                          </p>
                          <p className="text-xs text-gray-400">
                            Processed: {currentPage} / {Math.ceil(trainingDocuments.length / documentsPerPage)}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  appraisal.map((appraisalData, index) => (
                    <div key={index} className="mb-4">
                      <div className="p-3 bg-gradient-to-br from-gray-800/60 to-blue-800/60 rounded-lg border border-blue-500/30 mb-3">
                        <h5 className="text-sm font-bold text-blue-300 mb-2"> Appraisal Data</h5>
                        <p className="text-xs text-gray-300">Advanced performance analysis and feedback matrix.</p>
                      </div>

                      <div className="flex gap-2 mb-3">
                        <button
                          onClick={() => setStaffData({ id: appraisalData.StaffId })}
                          className="flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white py-2 px-3 rounded-lg text-xs font-bold border border-indigo-400/50"
                        >
                          📊 View Profile
                        </button>
                        {staffData && (
                          <button
                            onClick={() => setStaffData(null)}
                            className="flex-1 bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-500 hover:to-pink-500 text-white py-2 px-3 rounded-lg text-xs font-bold border border-red-400/50"
                          >
                            ✕ Hide Profile
                          </button>
                        )}
                      </div>

                      {staffData && (
                        <div className="mb-3">
                          <IndividualStaffData staff={staffData} />
                        </div>
                      )}

                      {!staffData && (
                        <div className="space-y-2">
                          {[
                            { label: " ID", value: appraisalData.StaffName },
                            { label: "Review Cycle Start", value: appraisalData.ReviewPeriodFrom ? format(new Date(appraisalData.ReviewPeriodFrom), 'MMM dd, yyyy') : 'N/A' },
                            { label: "Review Cycle End", value: appraisalData.ReviewPeriodTo ? format(new Date(appraisalData.ReviewPeriodTo), 'MMM dd, yyyy') : 'N/A' },
                            { label: "Performance Index", value: appraisalData.OverallPerformance },
                            { label: "Core Strengths", value: appraisalData.KeyStrengths },
                            { label: "Enhancement Areas", value: appraisalData.AreasForImprovement },
                          ].slice(0, 6).map(({ label, value }, i) => (
                            <div key={i} className="p-2 bg-gray-800/40 rounded border border-gray-600/20">
                              <div className="text-xs font-medium text-cyan-300">{label}</div>
                              <div className="text-xs text-gray-200 mt-1 break-words">{value || 'N/A'}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Mobile NoteTaker Card - Removed */}
          </div>
        </div>
      </div>
      </>
    );
    
}
